export class GetClassificationPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationPolicy",
            "baseName": "classificationPolicy",
            "type": "ClassificationPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetClassificationPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
